import moment from 'moment'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'
import eventBus from './plugins/eventBus'
import xlsx     from    'xlsx';
const _ = require('lodash');
const notyf = new Notyf({duration: 6000})
const notyf_short = new Notyf({duration: 2000})

const Mixins = {

    methods: 
    {
        isTouchDevice() 
        {
            return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        },

        notyfMesg(msg, type = '')
        {
            if(type == 'error')
            {
                notyf.error(msg)
                return
            }
            notyf.success(msg)
        },

        async defaultProjectTaskCoincidence(floor_id, daily_task_id)
        {
            if(floor_id !== '' && daily_task_id !== '')
            {
                let json_quest = {
                    lookingfor: true,
                    floor_id,
                    daily_task_id,
                }
                this.loader(true)
                let route_query = `default_project_codes/${JSON.stringify(json_quest)}`
    
                let response = await this.get(route_query)
    
                if(response.status)
                {
                    this.loader()
                    return response.data ? notyf_short.success('Project tasks found for the default project code') : notyf_short.error('No project tasks found for the default project code')
                }
                else
                {
                    this.error_handling(response)
                    this.loader()
                }
            }
        },

        currentDateToString()
        {
            return new Date().toISOString().split('T')[0]
        },

        currentTimeToString()
        {
            let current_date = new Date() 
            let hour = current_date.getHours() < 10 ? `0${ current_date.getHours() }` : current_date.getHours()
            let minutes = current_date.getMinutes() < 10 ? `0${ current_date.getMinutes() }` : current_date.getMinutes()
            return `${hour}:${minutes}`
        },

        getTodayRange() 
        {
            const startOfToday = moment().startOf('today')
            const endOfToday = moment().endOf('today')

            return [
                startOfToday.toDate(),
                endOfToday.toDate(),
            ];
        },

        getYesterdayRange() 
        {
            const startOfYesterday = moment().subtract(1, 'days').startOf('day');
            const endOfYesterday = moment().subtract(1, 'days');

            return [
                startOfYesterday.toDate(),
                endOfYesterday.toDate(),
            ];
        },

        getThisMonthRange() 
        {
            const startOfThisMonth = moment().startOf('month')
            const endOfThisMonth = moment().endOf('month')

            return [
                startOfThisMonth.toDate(),
                endOfThisMonth.toDate(),
            ];
        },

        getThisYearRange() 
        {
            const startOfThisYear = moment().startOf('year')
            const endOfThisYear = moment().endOf('year')

            return [
                startOfThisYear.toDate(),
                endOfThisYear.toDate(),
            ];
        },

        getLastMonthRange() 
        {
            const startOfLastMonth = moment().subtract(1, 'month').startOf('month');
            const endOfLastMonth = moment().subtract(1, 'month').endOf('month');

            return [
                startOfLastMonth.toDate(),
                endOfLastMonth.toDate(),
            ];
        },

        getThisWeekRange() 
        {
            const startOfWeek = moment().startOf('week')
            const endOfWeek = moment().endOf('week')

            return [
                startOfWeek.toDate(),
                endOfWeek.toDate(),
            ];
        },

        getLastWeekRange() 
        {
            const startOfWeek = moment().subtract(7, 'days')
            const endOfWeek = moment()

            return [
                startOfWeek.toDate(),
                endOfWeek.toDate(),
            ];
        },

        dateDecrement(numberOfDecrease)
        {
            let current_date = this.currentDateToString()

            let currentDate = new Date(current_date)

            let countableDate = new Date(currentDate)

            countableDate.setDate( currentDate.getDate() - numberOfDecrease )

            let day = countableDate.getDate() + 1
            let month = countableDate.getMonth() + 1
            let year = countableDate.getFullYear()

            if(day > 31)
            {
                day = 31
            }
            else if( day === Number('29') && month === Number('02') )
            {
                day = Number('01')
                month = Number('03')
            }

            let real_month = month < 10 ? `0${month}` : month
            let real_day = day < 10 ? `0${day}` : day

            let original_format_date = `${year}-${real_month}-${real_day}`
            let basic_format_date = `${real_day}-${real_month}-${year}`

            let date_object = {
                day_number: (currentDate.getDay()+1),
                day,
                month,
                year,
                locate_date_string: countableDate.toLocaleDateString(),
                date_string: countableDate.toString(),
                original_format_date,
                basic_format_date,
            }

            return date_object
        },

        dateIncrement(current_date, number_of_days)
        {
            let currentDate = new Date(current_date)

            let countableDate = new Date(currentDate)

            countableDate.setDate( currentDate.getDate() + number_of_days )

            let day = countableDate.getDate() + 1
            let month = countableDate.getMonth() + 1
            let year = countableDate.getFullYear()

            if(day > 31)
            {
                day = 31
            }
            else if( day === Number('29') && month === Number('02') )
            {
                day = Number('01')
                month = Number('03')
            }

            let real_month = month < 10 ? `0${month}` : month
            let real_day = day < 10 ? `0${day}` : day

            let original_format_date = `${year}-${real_month}-${real_day}`
            let basic_format_date = `${real_day}-${real_month}-${year}`

            let date_object = {
                day_number: (currentDate.getDay()+1),
                day,
                month,
                year,
                locate_date_string: countableDate.toLocaleDateString(),
                date_string: countableDate.toString(),
                original_format_date,
                basic_format_date,
            }

            return date_object
        },

        dateInFormatObject(date)
        {
            let currentDate = new Date(date)

            let day = currentDate.getDate() + 1
            let month = currentDate.getMonth() + 1
            let year = currentDate.getFullYear()

            if(day > 31)
            {
                day = 31
            }
            else if( day === Number('29') && month === Number('02') )
            {
                day = Number('01')
                month = Number('03')
            }

            let real_month = month < 10 ? `0${month}` : month
            let real_day = day < 10 ? `0${day}` : day

            let original_format_date = `${year}-${real_month}-${real_day}`
            let basic_format_date = `${real_day}-${real_month}-${year}`

            let date_object = {
                day_number: (currentDate.getDay()+1),
                day,
                month,
                year,
                locate_date_string: currentDate.toLocaleDateString(),
                date_string: currentDate.toString(),
                original_format_date,
                basic_format_date,
            }

            return date_object
        },

        convertStringDateToObjectDate(date)
        {
            var date_parts = date.split('-');

            const object_date = new Date(date_parts[0], date_parts[1] - 1, date_parts[2]);

            return object_date
        },

        

        

        convertObjectDateToStringDate(date) 
        {
            if(date)
            {
                var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
        
                if (month.length < 2) 
                    month = '0' + month;
                if (day.length < 2) 
                    day = '0' + day;
            
                return [year, month, day].join('-');
            }

            return null
            
        },

        fullDaysCalculator(date_object)
        {
            let year = date_object.year
            let month = date_object.month
            let day = date_object.day

            return year * 365 + month * 30 + day
        },

        getTodayDate()
        {
            return moment().format('MM-DD-YY')
        },

        getMomentDate(date)
        {
            return moment(date)
        },

        getCurrentDatetime()
        {
            return moment()
        },

        getDateTimeFormat(date = null, format = '')
        {
            if(date)
            {
                date = this.convertObjectDateToStringDate(date)
                const currentDate = moment(date).startOf('day');
                const currentTime = moment().format('HH:mm');
                return currentDate.add(moment.duration(currentTime)).format(format);
            }

            return moment().format(format)
        },

        minutesCounter(time, minutes, subtract = false)
        {
            let timeDateWithFormat = this.dateTimeFormat(time)

            let dateString = subtract ? moment(timeDateWithFormat).subtract(minutes, 'm').toDate() : moment(timeDateWithFormat).add(minutes, 'm').toDate()

            let becomingToDateClass = new Date(dateString)

            let getHour = becomingToDateClass.getHours() < 10 ? `0${becomingToDateClass.getHours()}` : becomingToDateClass.getHours()

            let getMinutes = becomingToDateClass.getMinutes() < 10 ? `0${becomingToDateClass.getMinutes()}` : becomingToDateClass.getMinutes()

            let timeReturned = `${getHour}:${getMinutes}`

            return timeReturned
            /**
             * 
             * Instructions:
             * 
             * 1st Param: 'time' (type: time, required)
             * 
             * 2nd Param: 'minutes' (type: int, required)
             * 
             * This function works for increase the 'time' to a specific 'minute' declared,
             * for example if the time begins at 1:00 hours the param 'minute' contains 
             * an int value like 90 o 450 (it has no limit), The time starts to increase
             * al those minutes declared until get the hour expected
             * 
             * 
             */
        },

        counterBetweenTwoDates(last_date, current_date)
        {
            let diffMs = (current_date - new Date(last_date))
            // let diffDays = Math.floor(diffMs / 86400000) // days
            let diffHrs = Math.floor((diffMs % 86400000) / 3600000) // hours
            // let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000) // minutes
            return diffHrs
            // console.log(diffDays + " days, " + diffHrs + " hours, " + diffMins + " minutes")
        },

        counterDates(current_date)
        {
            let diffMs = (new Date() - new Date(current_date))
            // let diffDays = Math.floor(diffMs / 86400000) // days
            let diffHrs = Math.floor((diffMs % 86400000) / 3600000) // hours
            // let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000) // minutes
            return diffHrs
            // console.log(diffDays + " days, " + diffHrs + " hours, " + diffMins + " minutes")
        },

        fullDateTimeHour(date, time, hours = null)
        {
            let timeDateWithFormat = this.getFullDateTimeFormat(date, time)

            let dateString = hours !== null ? moment(timeDateWithFormat).add(hours, 'hours').toDate() : moment(timeDateWithFormat).toDate()

            return dateString
            /**
             * 
             * Instructions:
             * 
             * 1st Param: 'date' (type: date, required)
             * 
             * 2nd Param: 'time' (type: time, required)
             * 
             * 3rd Param: 'hours' (type: int, optional)
             * 
             * This function works to get full current DateTime 
             * 
             * But if hours is declared this function works to convert the current DateTime to
             * the future DateTime depending the hours
             * 
             */
        },

        getCurrentDateTime(date = null)
        {
            if(date)
            {
                date = this.convertObjectDateToStringDate(date)
                const currentDate = moment(date).startOf('day');
                const currentTime = moment().format('HH:mm');
                return currentDate.add(moment.duration(currentTime)).unix();
            }
            return moment().unix()
        },

        dateTimeFormat(time)
        {
            return Date.parse(`01/01/2011 ${time}`)
        },

        getFullDateTimeFormat(date, time)
        {
            return Date.parse(`${date} ${time}`)
        },

        numberStringFormat(number, decimals = null)
        {
            if(decimals)
            {
                return new Intl.NumberFormat(undefined, {
                    maximumFractionDigits: decimals
                  }).format(number);
            }
            
            return new Intl.NumberFormat().format(number)
        },

        stringToNumber(number)
        {
            if(number)
            {
                return parseFloat(number.replace(/,/g, ''));
            }
            return 0
        },

        timeIdentificator(time)
        {
            const staticTime = '11:59'
            return `${time} ${ this.dateTimeFormat(time) > this.dateTimeFormat(staticTime) ? 'PM' : 'AM' }`
        },

        sumArrays(array_number, float = null)
        {
            let number = array_number.reduce( (num1, num2) => { return num1 + num2 }, 0 ).toFixed(2)

            return float !== null ? parseFloat(number) : parseInt(number)
        },

        minutesBetweenHours(time_start, time_end)
        {
            let timeStartFormat = moment(time_start, "HH:mm")
            let timeEndFormat = moment(time_end, "HH:mm")

            let totalDuration = moment.duration(timeEndFormat.diff(timeStartFormat))
            let totalMinutesDuration = parseInt(totalDuration.asMinutes())
            return totalMinutesDuration
        },

        timeExactlyDuration(time_start, time_end)
        {
            let timeStartFormat = moment(time_start, "HH:mm")
            let timeEndFormat = moment(time_end, "HH:mm")

            let totalDuration = moment.duration(timeEndFormat.diff(timeStartFormat))

            let getHours = parseInt(totalDuration.asHours())
            let getMinutes = parseInt(totalDuration.asMinutes())%60
            return `${getHours} hour and ${getMinutes} minutes.`
        },

        timeAsMinutes(time)
        {
            let curr_time = moment.duration(time, "HH:mm").asMinutes()
            return parseInt( curr_time )
        },

        arrayLineJoining(array)
        {
            return array.join(', ')
        },

        async downloadReport(response = {}) 
        {
            const data = response.data;
            window.open(`${data.storage_report_path}/${data.url}`, "_blank");
        },

        getAuthorizationReportKey()
        {
            return window.localStorage.getItem('authorization_key')
        },

        getReportStorageData()
        {
            return JSON.parse( window.localStorage.getItem('report_storage_data') )
        },

        setReportAuthStorageData(storage_data, authorization_key)
        {
            window.localStorage.removeItem('authorization_key')
            window.localStorage.removeItem('report_storage_data')
            
            window.localStorage.setItem( 'authorization_key', authorization_key )
            window.localStorage.setItem( 'report_storage_data', JSON.stringify(storage_data) )
        },

        removeCompleteReportStorageData()
        {
            window.localStorage.removeItem('authorization_key')
            window.localStorage.removeItem('report_storage_data')
        },

        async api_request(rest_api)
        {
            this.loader(true)
            
            const response = await this.get(rest_api !== undefined ? rest_api : this.rest_api)

            this.loader()

            if(response.status)
            {
                this.fill_data(response.data)
            } 
            else
            {
                this.error_handling(response)
            }
        },

        async apiRequest(params, reset_list = false)
        {
            let url
            if (this.rest_api_pagination.includes("?")) 
            {
                url = `${this.rest_api_pagination}&page=${params.page}`;
            } 
            else 
            {
                url = `${this.rest_api_pagination}?page=${params.page}`;
            }

            const response = await this.post(url, params)

            this.loader()

            if(response.status)
            {
                await this.loadMoreRecords(response.data, reset_list)
            } 
            else
            {
                this.error_handling(response)
            }
        },

        async form_submit(ext, form_data_sent = null, queries = [])
        {
            ext !== undefined ? this.invoke_loader(null, ext) : this.invoke_loader('post')

            let form_data = !form_data_sent ? this.form_data : form_data_sent 

            let url = `${this.rest_api}?`

            queries.forEach(query => 
            {
                if(query.value)
                {
                    url += `${query.property}=${query.value}&`
                }
            });
            
            const response = await this.post(url, form_data)
            
            if(response.status)
            {
                this.$emit('unshiftObject', response.data.data)
                eventBus.$emit('unshiftObject', response.data.data)
                this.form_data = _.cloneDeep(this.form_backup);
                console.log(this.form_backup)
                console.log(this.form_data)
                notyf.success(`Success!`)
            } 
            else
            {
                this.error_handling(response)
                ext !== undefined ? this.revoke_loader(null, ext) : this.revoke_loader('post')

                return false
            }

            return true
        },


        async form_submit_update(id, index = null, ext, queries = [], success_message = `Updated success!`)
        {
            ext !== undefined ? this.invoke_loader(null, ext) : this.invoke_loader('patch')

            let url = `${this.rest_api}/${id}?`

            queries.forEach(query => 
            {
                if(query.value)
                {
                    url += `${query.property}=${query.value}&`
                }
            });

            const response = await this.patch(`${url}`, this.single_object)
            if(response.status)
            {
                let object_emition = {
                    single_object:  response.data.data,
                    index:          index !== null ? index : '',
                }
                this.$emit('spliceObject', object_emition)
                eventBus.$emit('spliceObject')
                notyf.success(success_message)
            } 
            else
            {
                this.error_handling(response)
                ext !== undefined ? this.revoke_loader(null, ext) : this.revoke_loader('patch')
            }
        },

        async status_update(id, object, index, endpoint)
        {
            this.invoke_loader('get')
            
            const response = await this.patch(`${endpoint}/${id}`, object)

            if(response.status)
            {
                let object_emition = {
                    single_object:  response.data.data,
                    index:          index,
                }
                this.$emit('spliceObject', object_emition)
                eventBus.$emit('spliceObject', object_emition)
                notyf.success(`Updated success!`)
                this.revoke_loader('get')
            } 
            else
            {
                this.error_handling(response)
                this.revoke_loader('get')
            }
        },

        async postingByPost(endpoint, data, ext_modal, open_modal = true, validate_token = true)
        {
            ext_modal !== undefined ? this.invoke_loader(null, ext_modal) : ''
            const response = await this.post(endpoint, data, {}, validate_token)
            if(response.status)
            {

                if(open_modal)
                {
                    ext_modal !== undefined ? this.revoke_loader(null, ext_modal) : ''
                    notyf.success(`Success!`)
                }
                else
                {
                    ext_modal !== undefined ? this.revoke_loader_with_close(null, ext_modal) : '' 
                    this.loader(false)  
                }
            } 
            else
            {
                this.error_handling(response)
                ext_modal !== undefined ? this.revoke_loader(null, ext_modal) : ''
            }
            return response
        },

        async queryGetByMethod(endpoint, data, method = null)
        {
            this.invoke_loader('get')
            const response =  method === 'post' ? await this.post(endpoint, data) : await this.patch(endpoint, data)
            if(response.status === false)
            {
                this.error_handling(response)
                this.revoke_loader('get')
                return false
            } 
            this.revoke_loader('get')
            return response
        },

        object_deletion(object_destroyed)
        {
            this.deletion_ext(this.rest_api, object_destroyed)
        },

        object_deletion_child(endpoint, object_destroyed)
        {
            this.deletion_ext(endpoint, object_destroyed)
        },

        async deletion_ext(endpoint, object_destroyed)
        {
            this.invoke_loader('delete')
            const response = await this.delete(`${endpoint}/${object_destroyed.id}`)
            this.revoke_loader('delete')
            if(response.status)
            {
                this.global_index   =   ''
                this.single_object  =   {}
                this.trashing(object_destroyed.index)
                notyf.success('Deleted success!')
                window.$('#static-deletion').modal('hide')
            } 
            else
            {
                this.error_handling(response)
            }
        },

        async json_destroyed(endpoint, json_object)
        {
            this.invoke_loader('delete')
            const response = await this.delete(`${endpoint}/${JSON.stringify(json_object)}`)
            this.revoke_loader('delete')
            if(response.status)
            {
                this.trashing(json_object.index)
                notyf.success('Success!')
                window.$('#static-deletion').modal('hide')
            } 
            else
            {
                this.error_handling(response)
            }
        },

        async massive_deletion(json_request)
        {
            this.loader(true)
            const response = await this.delete(`${this.rest_api}/${JSON.stringify(json_request)}`)
            if(response.status)
            {
                notyf.success('Success!')
                window.$('#static-deletion-massive').modal('hide')
                this.loader()
                return true
            }
            else
            {
                this.error_handling(response)
                this.loader()
                return false
            }
        },

        async massive_delete(ids, custom_api = null, retrieve_data = false, show_success_message = true)
        {
            const api = (custom_api) ? custom_api : this.rest_api
            
            this.loader(true)
            const response = await this.post(`${api}/massive_delete`, ids)
            if(response.status)
            {
                if(show_success_message)
                {
                    notyf.success('Success!')
                }
                window.$('#static-deletion-massive').modal('hide')
                this.loader()
                if(retrieve_data)
                {
                    return response
                }
                else
                {
                    return true
                }
            }
            else
            {
                this.error_handling(response)
                this.loader()
                return false
            }
        },

        error_handling(error, logout = true)
        {
            if(error.number_status === 401/* || error.number_status === 500*/)
            {
                if(logout)
                {
                    this.logout()
                }
                notyf.error(error.data.message)
            }
            else if(error.number_status === 403)
            {
                if(error.data.middleware && error.data.middleware == 'ensure_change_of_password')
                {
                    window.location.href = '/change-password-after-days'
                }
                
            }
            else if(error.number_status === 422)
            {
                for ( const e in error.data.errors )
                {
                    notyf.error(error.data.errors[e][0])
                }
            }
            else if(typeof error.data === 'object')
            {
                notyf.error(`${error.data.message}`)
            }  
        },

        get_loader()
        {
            eventBus.$emit('showModal', {})
        },

        hide_loader()
        {
            eventBus.$emit('hideModal', {})
        },

        loader(bool = false)
        {
            if(bool)
            {
                eventBus.$emit('showModal', {})
            }
            else
            {
                setTimeout(() => {
                    eventBus.$emit('hideModal', {})
                }, 300)
            }
        },

        invoke_loader(request, ext)
        {
            if(ext !== undefined)
            {
                window.$(`#${ext}`).modal('hide')
                eventBus.$emit('showModal', {})
                return true
            }

            if(request === 'get' || request === 'delete')
            {
                eventBus.$emit('showModal', {})
            }
            else if(request === 'post')
            {
                window.$('#static').modal('hide')
                eventBus.$emit('showModal', {})
            }
            else if(request === 'patch')
            {
                window.$('#static-update').modal('hide')
                eventBus.$emit('showModal', {})
            }
            else
            {
                window.$('#static-update').modal('hide')
                eventBus.$emit('showModal', {})
            }
        },

        revoke_loader(request = null, ext)
        {
            if(ext !== undefined)
            {
                eventBus.$emit('hideModal', {})
                setTimeout(()=>
                {
                    window.$(`#${ext}`).modal('show')
                }, 500)
                return true
            }

            if(request !== null)
            {
                if(request === 'get' || request === 'delete')
                {
                    eventBus.$emit('hideModal', {})
                }
                else if(request === 'post')
                {
                    eventBus.$emit('hideModal', {})
                    setTimeout(()=>
                    {
                        window.$('#static').modal('show')
                    }, 500)
                }
                else if(request === 'patch')
                {
                    eventBus.$emit('hideModal', {})
                    setTimeout(()=>
                    {
                        window.$('#static-update').modal('show')
                    }, 500)
                }
            }
        },

        revoke_loader_with_close(request, close = null, ext = null)
        {
            if(request === 'get' || request === 'delete')
            {
                eventBus.$emit('hideModal', {})
            }
            else if(request === 'post')
            {
                setTimeout(()=>
                {
                    eventBus.$emit('hideModal', {})
                    
                    if(close !== null && !close)
                    setTimeout(() => { 
                        window.$(`#${ext ? ext : 'static'}`).modal('show')
                    }, 500);
                }, 0)
            }
            else if(request === 'patch')
            {
                
                eventBus.$emit('hideModal', {})

                if(close != null && !close)
                setTimeout(() => {       
                    window.$(`#${ext ? ext : 'static-update'}`).modal('show')
                }, 500);
            }
            
        },

        LoaderOffModalOn(modalName, close = null)
        {
            setTimeout(()=>
            {
                eventBus.$emit('hideModal', {})
                
                if(close !== null && !close)
                {
                    window.$(`#${modalName}`).modal('show')
                }
            }, 1500)
        },

        LoaderOnModalOff(modalName)
        {
            eventBus.$emit('showModal', {})
            setTimeout(()=>
            {
                window.$(`#${modalName}`).modal('hide')
            }, 500)
        },

        is_authenticated()
        {
            return localStorage.getItem('access_token') !== null;
        },
        
        logout()
        {
            setTimeout(() => 
            {
                if( this.is_authenticated() )
                {
                    this.post('auth/logout')
                }
                localStorage.removeItem('access_token')
                window.location.href = '/'
            }, 1000);
        },

        get_user()
        {
            return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
        },

        async delay(time)
        {
            return new Promise(resolve => {
                setTimeout(() => {
                    return resolve(true);
                }, time)
            })
        },

        get_content_excel(data)
        {
            const content = xlsx.read(data, { type: 'binary', raw: true });
            const sheet = content.SheetNames[0]
            const fields = xlsx.utils.sheet_to_json(content.Sheets[sheet])
            for(const item of fields) {
                for (const key in item) {
                   item[key] = String(item[key]).replace(/['"=]+/g, '')
                }
            }
            return fields
        },

    async downloadFile(response = {}, return_blob) 
    {
      const data = response.data
      const fileExtension = data.url.split('.').pop().toLowerCase();

      let contentType;

      if (fileExtension === 'pdf') 
      {
        contentType = 'application/pdf';
      } 
      else if (fileExtension === 'xlsx' || fileExtension === 'xls') 
      {
        contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } 
      else if (fileExtension === 'csv') 
      {
        contentType = 'text/csv';
      }
      else if (fileExtension === 'docx' || fileExtension === 'doc') 
      {
        contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      }
      else 
      {
        this.notyfMesg('Unsupported file type', 'error');
      }

      const base64Data = `data:${contentType};base64,${data.base64_file}`;

      const blob = this.base64ToBlob(base64Data);

      if(return_blob)
      {
        return blob
      }

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = data.url;
      link.click();
    },

    base64ToBlob(base64Data) {
      try 
      {
          const dataUrlRegex = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-+.]+)?;base64,(.+)$/;
          const matches = base64Data.match(dataUrlRegex);
      
          if (!matches) 
          {
            throw new Error('Invalid base64 data URL format');
          }
      
          const [, contentType, base64] = matches;
      
          const byteCharacters = atob(base64);
          const byteArrays = new Uint8Array(byteCharacters.length);
      
          for (let i = 0; i < byteCharacters.length; i++) 
          {
            byteArrays[i] = byteCharacters.charCodeAt(i);
          }
    
          return new Blob([byteArrays], { type: contentType });
        } 
        catch (error) 
        {
          console.error('Error converting base64 to blob:', error);
          throw error;
        }

    },

        parse_boolean(value)
        {
            if (String(value).toLowerCase() === 'true')
            {
                return true
            } 
            else if (String(value).toLowerCase() === 'false')
            {
                return false
            } 
            else if(String(value).toLowerCase() === ''  || value === undefined)
            {
                return undefined
            }
            else
            {
                return String(value).trim()
            }
        },

        parse_upload_data(value)
        {
            if (String(value).toLowerCase() === 'true')
            {
                return true
            } 
            else if (String(value).toLowerCase() === 'false')
            {
                return false
            } 
            else if(String(value).toLowerCase() === ''  || value === undefined)
            {
                return null
            }
            else
            {
                return String(value).trim()
            }
        },
        
    },

}

export default Mixins
// SELECT name, CAST(REGEXP_SUBSTR(name, "[0-9]{1,}") as integer) as num FROM `levels` WHERE name LIKE '%level%' ORDER BY num , name ASC